<template lang="html">
  <bar-chart :chartData="chartData" :options="options" v-if="chartData !== undefined"></bar-chart>
  <spinner v-else></spinner>
</template>

<script>
import BarChart from '@/pages/statistics/components/graphiques/BarChart.vue'
import Spinner from '@/components/common/spinner.vue'
import * as R from 'ramda'

export default {
  props: ['showTransactionsNotTreasury'],
  data () {
    return {
      chartData: undefined,
      options: undefined
    }
  },
  components: {
    'bar-chart': BarChart,
    'spinner': Spinner
  },
  mounted () {
    let dates = this.$engine.monitoring.getDatesFromPeriode('month')
    let serviceId = '6'
    this.$engine.monitoring.fetchPromise({
      'service': serviceId,
      'dateBegin': dates.begin,
      'dateEnd': dates.end,
      'getDate': 1,
      'getIban': 1,
      'getContact': 1
    }).then(resp => {
      this.$engine.monitoring.rawByBalance = resp.data[serviceId]
      const filteredData = this.$engine.monitoring.applyFilterOnData(resp.data[serviceId], this.$engine.monitoring.filterGraphBalance)
      this.$engine.monitoring.graphByBalance = this.$engine.monitoring.makeGraphByBalance(filteredData, serviceId)
      if (this.showTransactionsNotTreasury) {
        this.chartData = this.makeChartDataSentReceived(this.$engine.monitoring.graphByBalance)
      } else {
        this.chartData = this.makeChartDataTreasuryBalance(this.$engine.monitoring.graphByBalance)
      }
    })
  },
  watch: {
    '$engine.monitoring.graphByBalance': {
      handler (val) {
        if (val === undefined) {
          this.chartData = undefined
        } else {
          if (this.showTransactionsNotTreasury) {
            this.chartData = this.makeChartDataSentReceived(this.$engine.monitoring.graphByBalance)
          } else {
            this.chartData = this.makeChartDataTreasuryBalance(this.$engine.monitoring.graphByBalance)
          }
        }
      },
      deep: true
    },
    showTransactionsNotTreasury: {
      handler () {
        if (this.$engine.monitoring.graphByStatus !== undefined) {
          if (this.showTransactionsNotTreasury) {
            this.chartData = this.makeChartDataSentReceived(this.$engine.monitoring.graphByBalance)
          } else {
            this.chartData = this.makeChartDataTreasuryBalance(this.$engine.monitoring.graphByBalance)
          }
        }
      }
    }
  },
  methods: {
    makeChartDataSentReceived (rawData) {
      let dataSent = []
      let dataToSend = []
      let dataReceived = []
      let dataToReceive = []

      // Init chart data
      let chartData = {
        labels: rawData.dates,
        datasets: []
      }

      this.options = {
        responsive: true,
        scales: {
          yAxes: [{
            stacked: true
          }]
        }
      }

      // Make data for datasets
      rawData.dates.forEach(date => {
        dataSent = R.append(rawData.sent[date], dataSent)
        dataToSend = R.append(rawData.tosend[date], dataToSend)
        dataReceived = R.append(rawData.received[date], dataReceived)
        dataToReceive = R.append(rawData.toreceive[date], dataToReceive)
      })

      // Make datasets
      chartData.datasets = R.append({ // Dataset Received
        label: this.$i18n.t('graph.rcvd'),
        backgroundColor: '#65C694',
        data: dataReceived,
        stack: 1
      }, chartData.datasets)
      chartData.datasets = R.append({ // Dataset To Receive
        label: this.$i18n.t('graph.to_rcv'),
        backgroundColor: '#51a45c',
        data: dataToReceive,
        stack: 1
      }, chartData.datasets)
      chartData.datasets = R.append({ // Dataset Sent
        label: this.$i18n.t('graph.snt'),
        backgroundColor: '#f56954',
        data: dataSent,
        stack: 2
      }, chartData.datasets)
      chartData.datasets = R.append({ // Dataset To Send
        label: this.$i18n.t('graph.to_snd'),
        backgroundColor: '#d54934',
        data: dataToSend,
        stack: 2
      }, chartData.datasets)

      return chartData
    },
    makeChartDataTreasuryBalance (rawData) {
      let dataTreasury = []
      let dataBalance = []

      // Init chart data
      let chartData = {
        labels: rawData.dates,
        datasets: []
      }

      this.options = {responsive: true}

      // Make data for datasets
      rawData.dates.forEach(date => {
        dataTreasury = R.append(rawData.treasury[date], dataTreasury)
        dataBalance = R.append(rawData.balance[date], dataBalance)
      })

      // Make datasets
      chartData.datasets = R.append({ // Dataset Treasury
        label: 'Treasury',
        backgroundColor: '#12bcf1',
        data: dataTreasury
      }, chartData.datasets)
      chartData.datasets = R.append({ // Dataset Balance
        label: 'Balance',
        backgroundColor: '#39cccc',
        data: dataBalance
      }, chartData.datasets)

      return chartData
    }
  }
}
</script>

<style lang="css" scoped>
</style>
